
export enum StylePenaltyType {
	TripleRon,
	Loss,
	Dama,
	PinfuNomi,
	OpenHand,
}
